<div class="edit-post-container">
    <!-- *ngIf="isPosting" -->
    <div class="posting-overlay" *ngIf="isPosting">
        <div class="spinner-wrapper">
            <div class="spinner-border" role="status"></div>
            <div class="spinner-border-text">{{ action }}</div>
        </div>
    </div>
    <div class="edit-post-header">
        <span class="edit-post-header-title">{{ title }}</span>
        <span class="edit-post-header-icon" (click)="close(null)"><i class="fas fa-times edit-post-close-btn"></i></span>
    </div>
    <mat-divider class="edit-post-divider"></mat-divider>
    <div class="edit-post-body">
        <div class="user-info">
            <img class="user-info-avatar" src="{{post?.avatar}}" alt="{{post.avatar}}" mat-card-avatar>
            <div class="user-info-title">
                <span class="user-info-title-name">{{ post?.firstName }} {{ post?.lastName }}</span>
                <span class="user-info-title-privacy">
                    <i class="fas fa-globe-europe fa-fw"></i>
                    Public
                    <i class="fas fa-caret-down fa-fw"></i>
                </span>
            </div>
        </div>
        <div class="edit-post-scrollable">
            <div class="edit-post-toolbar">
                <i class="far fa-smile fa-fw edit-post-toolbar-emoji emoji-pos-img" *ngIf="isImage()" ></i>
            </div>
            <form class="edit-post-form" [formGroup]="editPostForm">
                <textarea class="edit-post-form-textarea segoe-ui" [ngClass]="isImage() ? 'textarea-img' : 'textarea-no-img'" name="postText" type="text" formControlName="postText"></textarea>
                <div class="edit-post-image-wrapper">
                    <i class="fas fa-times image-delete" *ngIf="isImage()" (click)="clearImage()"></i>
                    <img [src]="imgSrc" class="edit-post-image-preview" *ngIf="isImage()">
                    <input type="file" accept="image/png, image/jpeg" name="imageSrc" formControlName="imageSrc" (change)="showPreview($event)" #imgUploader style="display: none; visibility: hidden;">
                </div>
            </form>
        </div>
        <div class="edit-post-toolbar" *ngIf="!isImage()">
            <img class="edit-post-toolbar-aa" src="../../../assets/Aa_square.png"/>
            <i class="far fa-smile fa-fw edit-post-toolbar-emoji emoji-pos-no-img" [ngbTooltip]="emojiTip" tooltipClass="edit-post-btn-tip" openDelay="250"></i>
            <ng-template #emojiTip>Emoji</ng-template>
        </div>
        <div class="edit-post-attached">
            <span class="edit-post-attached-left">Add to your post</span>
            <span class="edit-post-attached-right">
                <i class="fas fa-photo-video fa-fw" [ngbTooltip]="photoVideoTip" tooltipClass="edit-post-btn-tip" openDelay="250" (click)="imgUploader.click()"></i>
                <ng-template #photoVideoTip>Photo/Video</ng-template>

                <i class="fas fa-user-tag fa-fw" [ngbTooltip]="tagFriendsTip" tooltipClass="edit-post-btn-tip" openDelay="250" (click)="changePosting()"></i>
                <ng-template #tagFriendsTip>Tag friends</ng-template>

                <i class="far fa-smile fa-fw" [ngbTooltip]="feelingActivityTip" tooltipClass="edit-post-btn-tip" openDelay="250"></i>
                <ng-template #feelingActivityTip>Feeling/Activity</ng-template>

                <i class="fas fa-map-marker-alt fa-fw" [ngbTooltip]="checkInTip" tooltipClass="edit-post-btn-tip" openDelay="250"></i>
                <ng-template #checkInTip>Check in</ng-template>

                <i class="fas fa-comment fa-fw" [ngbTooltip]="hostQATip" tooltipClass="edit-post-btn-tip" openDelay="250"></i>
                <ng-template #hostQATip>Host a Q&A</ng-template>

                <i class="fas fa-ellipsis-h fa-fw" [ngbTooltip]="moreTip" tooltipClass="edit-post-btn-tip" openDelay="250"></i>
                <ng-template #moreTip>More</ng-template>
            </span>
        </div>
    </div>
    <div class="edit-post-footer">
        <button class="edit-post-save-btn" (click)="close(editPostForm)" [disabled]="!isModified()">{{ btnLabel }}</button>
    </div>
</div>